import LCLegendItem from './LCLegendItem/LCLegendItem'
import { landcoverData as values } from './lclegend.constants'

import './lclegend.styl'

function LCLegend({ className, title, isHorizontal, isGradient }) {
  return (
    <div className={`lclegend ${className ? className : ''}`}>
      {title
        && (
          <div className="lclegend__title">
            {title}
          </div>
        )}
      <ul className={`lclegend__list ${isHorizontal ? 'lclegend__list--horizontal' : ''}`}>
        {values.map(item => (
          <LCLegendItem
            key={isGradient ? `${item.color.min}_${item.color.max}` : item.color}
            color={item.color}
            label={item.label}
            isHorizontal={isHorizontal}
            isGradient={isGradient}
          />
        ))}
      </ul>
    </div>
  )
}

export default LCLegend
